import axios from "axios";

export default {
    data() {
        return {
            confirmTimezone: false,
            confirmPreferences: false,
            notificationPreferences: {},
            timezones: null,
            updateTimezone: this.$page.props.auth.user
                ? this.$page.props.auth.user.timezone
                : "America/New_York",
            showNewFeatures: false,
            newFeatures: [
                {
                    step: 1,
                    text: "New options to customize your calendar view",
                    img: "/newFeatures/calendar-options.png",
                },
                {
                    step: 2,
                    text: `Tap your student's profile photo to view their contact card`,
                    img: `/newFeatures/contact-card.png`,
                },
                {
                    step: 3,
                    text: "Sync your schedule with Google Calendar",
                    img: "/newFeatures/sync-calendar.png",
                },
            ],
            featureStep: 1,
            checkForUpdatesLoading: false,
            lastInteraction: Date.now(),
            refreshingData: false,
            interacting: false,
        };
    },
    mounted() {
        this.setupInactivityTimer();
        if (!this.$page.props.auth.user) return;

        this.showConfirmTimezone();
        this.showConfirmPreferences();
        this.showNewFeatures = this.$page.props.version.newFeatures;
    },
    beforeDestroy() {
        this.removeInactivityTimer();
    },
    methods: {
        // reset timer after every interaction
        setupInactivityTimer() {
            ["mousedown", "touchstart", "mousemove"].forEach((event) =>
                document.addEventListener(event, this.checkInactivity, {
                    capture: false,
                    once: false,
                    passive: true,
                })
            );
        },
        removeInactivityTimer() {
            ["mousedown", "touchstart", "mousemove"].forEach((event) =>
                document.removeEventListener(event, this.checkInactivity, {
                    capture: false,
                    once: false,
                    passive: true,
                })
            );
        },
        // reset timer
        // if it's been more than 5 minutes, refresh data
        checkInactivity() {
            if (this.interacting) return;

            this.interacting = true;
            requestAnimationFrame((time) => {
                this.interacting = false;
                const userWasInactive = time - this.lastInteraction > 5 * 60000; // 5 minutes
                this.lastInteraction = time;
                if (userWasInactive) {
                    this.refreshData();
                }
            });
        },
        async refreshData() {
            if (this.refreshingData) return;
            this.refreshingData = true;

            const updateAvailable = await axios
                .get(
                    `/user/check-for-updates/${this.$page.props.version.number}`
                )
                .then((res) => res.data);

            if (updateAvailable) {
                window.location.reload();
            } else {
                this.$inertia.reload({
                    preserveState: true,
                    preserveScroll: true,
                    onSuccess: (page) => {
                        this.refreshingData = false;
                        this.showConfirmTimezone();
                        this.showConfirmPreferences();
                        this.showNewFeatures = page.props.version.newFeatures;
                    },
                    onError: () => {},
                });
            }
        },
        submitTimezone() {
            this.$inertia.put(`/user/timezone`, {
                timezone: this.updateTimezone,
                url: window.location.href,
            });
        },
        showConfirmTimezone() {
            // confirm timezone modal
            if (!this.$page.props.version.newTimezone) return;
            this.confirmTimezone = true;
            this.timezones = moment.tz.zonesForCountry("US");
        },
        submitPreferences() {
            this.$inertia.put(
                `/user/confirm-preferences`,
                {
                    notification_preferences: this.notificationPreferences,
                },
                {
                    preserveState: false,
                    preserveScroll: true,
                    onSuccess: () => {
                        //this.$refs.preferencesForm.dialog = false;
                        this.showMessage = true;
                        this.confirmPreferences = false;
                    },
                    onError: (errors) => {
                        console.log(
                            "Form returned errors: " + JSON.stringify(errors)
                        );
                    },
                }
            );
        },
        async showConfirmPreferences() {
            // confirm notification preferences modal
            if (!this.$page.props.version.newPreferences) return;
            await axios
                .get(`/api/users/preferences/${this.$page.props.auth.user.id}`)
                .then((resp) => {
                    this.notificationPreferences = resp.data;
                });
            this.confirmPreferences = true;
        },
        closeNewFeatures() {
            this.$refs.features.dialog = false;
            setTimeout(() => {
                this.showNewFeatures = false;
            }, 300);
            this.$inertia.put(
                `/user/clear-new-features`,
                {
                    url: window.location.href,
                },
                {
                    preserveState: false,
                }
            );
        },
    },
};
